import React from "react";
import { Route, Switch } from "react-router";
import MegafonPage from "./MegafonPage"
import MegafonMessagesPage from "./MegafonMessagesPage";

export const navLinks = [
    {path: "/megafon", text: "Megafon channels"},
    {path: "/megafon/messages", text: "Sms messages"}
]

export default function GreenApiPage() {
    return (
        <>
            <Switch>
                <Route exact path="/megafon" component={MegafonPage}/>
                <Route exact path="/megafon/messages" component={MegafonMessagesPage}/>
            </Switch>
        </>
    )
}